<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Settings",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Settings",
            items: [
               {
                  text: "Settings",
                  active: true,
               },                   
            ],
            admin_name: 'admin',
            username: 'admin@sigomind.com',
         
            password: "",
            password_confirmation: "",

            show_password: false,
            show_confirm_password: false,
            errors: {},
         };
      },
      mounted() {
    
      },

      methods: {

         getToken() {
            if (localStorage.getItem('sigomind_admin')) {
               var sigomind_admin =  JSON.parse(localStorage.getItem('sigomind_admin'));
               if(sigomind_admin.token) {

                  this.token = sigomind_admin.token;
                  this.user = sigomind_admin;

               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }

            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         togglePassword() {
            if(this.show_password == false) {
               this.show_password = true;
            } else {
                this.show_password = false;
             }
         },

         toggleConfirmPassword() {
            if(this.show_confirm_password == false) {
               this.show_confirm_password = true;
            } else {
               this.show_confirm_password = false;
            }
         },
         
         changePassword() {

            this.getToken();
            this.errors = {};

            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            var data = JSON.stringify({
               "password": this.password,
               "password_confirmation": this.password_confirmation
            });

            this.loading = true;

            this.$axios
               .put("admin/admin/change-password", data, config)
               .then((response) => {
                  console.log(response);

                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.$router.push({ name: "settings" });
               })
               .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
               } 
               else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }

            });
            //.finally(() => (this.loading = false));
         },

         clearForm() {
            this.password = "";
            this.password_confirmation = "";
          
         },

      }

   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Admin Details</h4>
                  <b-form>
                     <b-row>
                        <b-col md="4" lg="5" class="form-group">
                           <label class="control-label">Name</label>
                           <b-form-input v-model="admin_name"></b-form-input>
                        </b-col>

                        <b-col md="5" lg="5" class="form-group">
                           <label class="control-label">Username</label>
                           <b-form-input v-model="username"></b-form-input>
                        </b-col>

                        <b-col md="3" lg="2" class="form-group">
                        </b-col>
                        <b-col md="9" lg="10" class="form-group">
                           <label class="control-label">Admin image <span class="note">[Allowed Formats: jpg, jpeg, png.]</span></label>
                           
                           <input ref="fileinput" id="fileinput" type="file" accept="image/*" class="form-control image-class" />
                           
                           <div class="note">Leave this field empty if you don't want to add/edit the image</div>
                           
                        </b-col>
                        <b-col md="3" lg="2">
                           <b-button type="submit" class="submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>

            <!-- <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Change Password</h4>
                  <b-form>
                     <b-row class="d-flex">
                        <b-col md="5" class="form-group">
                           <label class="control-label">Password</label>
                           <b-form-input type="password" v-model="password"></b-form-input>
                           
                        </b-col>

                        <b-col md="5" class="form-group">
                           <label class="control-label">Confirm Password</label>
                           <b-form-input type="password" v-model="password_confirmation"></b-form-input>
                        </b-col>
                        <b-col md="2">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div> -->

            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Change Password</h4>
                  <b-form @submit.prevent="changePassword()">
                     <b-row class="d-flex">
                        <b-col md="5" class="form-group">
                           <label class="control-label">Password</label>
                           <b-input-group>
                              <b-form-input type="password" v-model="password"  v-if="!show_password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                              <b-form-input type="text" v-model="password" v-else v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                              <b-input-group-text @click="togglePassword()">
                                 <i class="fas fa-eye" v-if="show_password"></i>
                                 <i class="fas fa-eye-slash" v-else></i>
                              </b-input-group-text>
                               
                               
                              <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-input-group>
                           
                        </b-col>

                        <b-col md="5" class="form-group">
                           <label class="control-label">Confirm Password</label>
                           <b-input-group>
                                 <b-form-input type="password" v-model="password_confirmation" v-if="!show_confirm_password" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"></b-form-input>
                                 <b-form-input type="text" v-model="password_confirmation" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }" v-else></b-form-input>
                                 <b-input-group-text @click="toggleConfirmPassword()">
                                    <i class="fas fa-eye" v-if="show_confirm_password"></i>
                                    <i class="fas fa-eye-slash" v-else></i>
                                 </b-input-group-text>

                                 <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>                              
                           </b-input-group>
                        </b-col>

                        <b-col md="2" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary">Update</b-button>
                        </b-col>
                        
                     </b-row>
                  </b-form>
               </div>
            </div>

         </div>
      </div>
   </Layout>
</template>
